export const ERROR_HANDLE_FETCH = 'errorHandler/ERROR_HANDLE_FETCH';
export const ERROR_HANDLE_DATA = 'errorHandler/ERROR_HANDLE_DATA';
